<script lang="ts">
	import Icon from '../icon/Icon.svelte'
	import type { IconSource } from '@steeze-ui/heroicons'
	import { type Snippet } from 'svelte'

	interface Props {
		title: string
		icon?: IconSource
		customIcon?: boolean
		selected?: boolean
		href?: string | null
		target?: string | null
		name?: string | null
		disabled?: boolean
		stopPropagation?: boolean
		iconSlot?: Snippet
		class?: string
		onclick?: (event: Event) => void
	}

	let {
		title,
		icon = null,
		customIcon = false,
		selected = false,
		href = null,
		target = null,
		name = null,
		disabled = false,
		stopPropagation = false,
		iconSlot,
		class: className = '',
		onclick = null,
	}: Props = $props()

	function handleClick(event: Event) {
		if (stopPropagation) {
			event.stopPropagation()
		}

		if (!href) {
			event.preventDefault()
		}

		if (onclick) {
			onclick(event)
		}
	}
</script>

<a
	class="flex items-center rounded-md px-3 py-2 text-base hover:bg-gray-100 dark:hover:bg-gray-600 {disabled
		? 'pointer-events-none opacity-50'
		: ''} {className}"
	data-test={name ? `button-${name}` : null}
	href={href || '#link'}
	{target}
	onclick={handleClick}
>
	{#if icon || customIcon}
		<div class="flex h-5 w-5 justify-center">
			{#if iconSlot}{@render iconSlot()}{:else}
				<Icon outline src={icon} />
			{/if}
		</div>
		<div class="ml-3"></div>
	{/if}
	<span class="whitespace-nowrap {selected ? 'font-bold' : ''}">
		{title}
	</span>
</a>
